module.exports = __webpack_public_path__ + "img/replay-button.d4bdea6e.png";